import { useMutation } from "react-query";
import { forgotten, reset, resetWelcome } from "../services/api/auth";

export default function useWelcomePassword() {
	return useMutation(({ password, token }: { password: string; token: string }) => {
		return resetWelcome(password, token);
	});
}
